import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row-minus-25" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex px-4 py-3 bg-light" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-0" }, "Select day")
], -1)
const _hoisted_3 = { class: "d-flex p-4 pb-3" }
const _hoisted_4 = {
  class: "nav category-item-tabs",
  role: "tablist"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "d-flex p-4 pb-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "- Select - ", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "d-flex justify-content-between px-4 py-3 bg-light" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-0" }, "Select time", -1)
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" tables left ")
const _hoisted_16 = { class: "d-flex p-4" }
const _hoisted_17 = {
  key: 0,
  class: "nav category-item-tabs"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "btn btn-outline-secondary text-muted py-1 px-3 mb-2 text-center disabled" }, " No Dine-in option for this day ", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "d-flex justify-content-center w-100 fa-2x"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex px-4 py-3 bg-light" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-0" }, "Select total guests")
], -1)
const _hoisted_26 = { class: "d-flex p-4" }
const _hoisted_27 = { class: "nav category-item-tabs" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex px-4 py-3 bg-light" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-0" }, "Smoking preferences")
], -1)
const _hoisted_31 = { class: "d-flex p-4" }
const _hoisted_32 = {
  class: "nav category-item-tabs",
  role: "tablist"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex px-4 py-3 bg-light" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-0" }, "Preferred area")
], -1)
const _hoisted_36 = { class: "d-flex p-4" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "- Select - ", -1)
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "p-3 d-flex text-white primary-gradient-bg rounded-3 w-75 m-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "fa-2x me-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle" })
], -1)
const _hoisted_44 = { class: "mb-0" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Please note, the venue is currently closed. You will receive your confirmation as soon as possible. ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" You will receive a response to your request within a few minutes. ")
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "p-4 d-flex align-items-end justify-content-end h-100" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold me-3" }, " REQUEST TABLE: ", -1)
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = { class: "me-2" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_54 = { class: "me-2 d-flex align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock me-2" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_57 = { class: "d-flex align-items-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-user me-2" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_60 = {
  id: "payment-modal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#PaymentModal",
  class: "d-none",
  ref: "triggerPayment"
}
const _hoisted_61 = {
  id: "requestsent-modal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#RequestSentModal",
  class: "d-none",
  ref: "triggerRequest"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_modal = _resolveComponent("payment-modal")!
  const _component_request_sent_modal = _resolveComponent("request-sent-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slot_days, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item me-2",
            key: item
          }, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["btn py-1 px-3 mb-2", item.value == _ctx.selected_day ? 'btn-primary text-white' : 'btn-outline-primary']),
              onClick: _withModifiers(($event: any) => (_ctx.updateDate(item.value, true)), ["prevent"])
            }, _toDisplayString(item.label), 11, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    (_ctx.is_otherday)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select white-select material-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.other_day_slection) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeOtherDay()))
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.other_days_list, (day) => {
              return (_openBlock(), _createElementBlock("option", {
                key: day,
                value: day
              }, _toDisplayString(day), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.other_day_slection]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      (_ctx.selected_availability_slot != null && _ctx.selected_availability_slot.availability == 'NA')
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "No tables left"))
        : _createCommentVNode("", true),
      (_ctx.selected_availability_slot != null && _ctx.selected_availability_slot.availability == 'LA')
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
            (_ctx.selected_availability_slot.tables_left != null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.selected_availability_slot.tables_left), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, "Few ")),
            _hoisted_15
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.loading_panel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.dinein_available)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availability_slots, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-item me-2",
                      key: item
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass(["btn py-1 px-3 mb-2", [_ctx.selected_time == _ctx.getTime(item.timeslot) ? 'btn-primary' :
                                    (item.availability == 'A' ? 'btn-outline-success' : (item.availability == 'LA' ? 'btn-outline-warning' : 'btn-outline-danger')),]]),
                        onClick: _withModifiers(($event: any) => (_ctx.selectTimeSlot(item, index)), ["prevent"])
                      }, _toDisplayString(_ctx.getTime(item.timeslot)), 11, _hoisted_18)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("ul", _hoisted_27, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.max_people, (index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item me-2",
            key: index
          }, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["btn py-1 px-3 mb-2", [index == _ctx.number_of_guests ? 'btn-primary' : 'btn-outline-primary',
                                !_ctx.dinein_available ? 'disabled' : '']]),
              onClick: _withModifiers(($event: any) => (_ctx.setNumberOfGuests(index)), ["prevent"])
            }, _toDisplayString(index), 11, _hoisted_28)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.restaurantDetails.has_table_reservation_management ? 'col-md-6' : 'col-md-12')
      }, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("ul", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smoking_area, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item me-2",
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["btn btn-outline-primary py-1 px-3 mb-2", [_ctx.smoking_preference == item.preferences ? 'active' : '',
                                    !_ctx.dinein_available ? 'disabled' : '']]),
                  onClick: _withModifiers(($event: any) => (_ctx.areaCategories(item)), ["prevent"])
                }, _toDisplayString(item.title), 11, _hoisted_33)
              ]))
            }), 128))
          ])
        ])
      ], 2),
      (_ctx.restaurantDetails.has_table_reservation_management)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select white-select material-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.preferred_area) = $event)),
                disabled: !_ctx.smoking_preference
              }, [
                _hoisted_38,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: area.id,
                    value: area.id
                  }, _toDisplayString(area.name), 9, _hoisted_39))
                }), 128))
              ], 8, _hoisted_37), [
                [_vModelSelect, _ctx.preferred_area]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("h6", _hoisted_44, [
            (_ctx.restaurantDetails.dine_in_is_closed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_45
                ], 64))
              : (!_ctx.restaurantDetails.dine_in_is_closed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_46
                  ], 64))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-primary btn-sm rounded-5 px-3 py-2 fw-bold d-flex align-items-center", !_ctx.isValidRequest() ? 'disabled' : '']),
            disabled: !_ctx.isValidRequest() || _ctx.submitting_request,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitRequest()))
          }, [
            _hoisted_50,
            _createElementVNode("span", _hoisted_51, [
              _createElementVNode("span", _hoisted_52, [
                (_ctx.display_date)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.display_date), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_53
                    ], 64))
              ]),
              _createElementVNode("span", _hoisted_54, [
                _hoisted_55,
                (_ctx.selected_time)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.selected_time), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_56
                    ], 64))
              ]),
              _createElementVNode("span", _hoisted_57, [
                _hoisted_58,
                (_ctx.number_of_guests)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.number_of_guests), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_59
                    ], 64))
              ])
            ])
          ], 10, _hoisted_49),
          _createElementVNode("button", _hoisted_60, "thank you", 512),
          _createElementVNode("button", _hoisted_61, "Request Sent", 512)
        ])
      ])
    ]),
    _createVNode(_component_payment_modal, {
      restaurantDetails: _ctx.restaurantDetails,
      orderID: _ctx.orderID
    }, null, 8, ["restaurantDetails", "orderID"]),
    _createVNode(_component_request_sent_modal, {
      social_links: _ctx.$store.state.social_links
    }, null, 8, ["social_links"])
  ]))
}